import { MenuLanguageModel } from './menu-language.model';
import { ReferentielModel } from './referentiel.model';

export class DiscDetailModel {
  public id: number = null;
  public laboratoryId: number = null;
  public menuLanguages: MenuLanguageModel[] = [];
  public startSequences: ReferentielModel[] = [];
  public menuAudioFormat: ReferentielModel = new ReferentielModel();
  public menuImageFormat: ReferentielModel = new ReferentielModel();
  public filmSpeedId: number = null;
  public laboratoryName: string = null;

  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
